<div id="toggler" class="row py-2 align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-lg-2 col-6">{{ group.notificationNumber }}</div>
    <div class="col-lg-3 col">{{ group.description }}</div>
    <div class="col-3 d-lg-block d-none">{{ group.customerName }}</div>
    <div class="col d-lg-block d-none">{{ formatDate(group.endDate) }}</div>
</div>
<div
    *ngIf="!isCollapsed"
    class="material-expanded-content py-3"
    [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
>
    <div *ngFor="let notificationDocuments of notifications" class="notification-documents-content pb-2">
        <div class="row d-lg-none d-block">
            <div class="col mb-1">
                <span class="fw-bold" translate="NOTIFICATION_HISTORY_DETAIL_NOTIFICATION_CUSTOMER_NAME_HEADER"></span>
                <span class="ps-2">{{ group.customerName }}</span>
            </div>
            <div class="col mb-1">
                <span class="fw-bold" translate="NOTIFICATION_HISTORY_DETAIL_NOTIFICATION_CRM_DATE_HEADER"></span>
                <span class="ps-2">{{ formatDate(group.endDate) }}</span>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-5 col-8 offset-lg-1">{{ notificationDocuments?.fileName }}</div>
            <div class="col-1 p-lg-0">
                <button
                    class="btn btn-small btn-secondary me-1"
                    #tooltip="bs-tooltip"
                    [tooltip]="'DOCBOX_DOWNLOAD_DOCUMENT_TOOLTIP' | translate"
                    (click)="downloadDocuments([notificationDocuments.docBoxId])"
                >
                    <fa-icon [icon]="faSave"></fa-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="row mt-2 me-3">
        <div class="col d-flex justify-content-end">
            <button
                class="btn btn-small btn-secondary me-3"
                #tooltip="bs-tooltip"
                [tooltip]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP' | translate"
                (click)="uploadDocument()"
            >
                <fa-icon [icon]="faCloudUpload"></fa-icon>
            </button>
            <button class="btn btn-primary" (click)="downloadDocuments(docBoxIds)">
                <span translate="DOCBOX_DOWNLOAD_ALL_BUTTON_LABEL"></span>
            </button>
        </div>
    </div>
    <hr class="separator" />
</div>
